import { render, staticRenderFns } from "./UpcomingBirthdayList.vue?vue&type=template&id=9a05caec&scoped=true&"
import script from "./UpcomingBirthdayList.vue?vue&type=script&lang=ts&"
export * from "./UpcomingBirthdayList.vue?vue&type=script&lang=ts&"
import style0 from "./UpcomingBirthdayList.vue?vue&type=style&index=0&id=9a05caec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a05caec",
  null
  
)

component.options.__file = "UpcomingBirthdayList.vue"
export default component.exports